const ProductsList = () => {
    return (
      <>
       <h2>Products List</h2>
      </>
    )
  }
  
  export default ProductsList